import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
    Container,
    Grid,
    Button,
    FormControl,
    FormGroup,
    FormControlLabel,
    Typography,
    TextField,
    List,
    ListItem,
    ListItemButton,
    IconButton,
    ListItemText,
    Switch,
    MenuItem
} from "@mui/material";
import DomainAddIcon from '@mui/icons-material/DomainAdd';
import EditIcon from '@mui/icons-material/Edit';
import DomainDisabledIcon from '@mui/icons-material/DomainDisabled';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PostAddIcon from '@mui/icons-material/PostAdd';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import { Link, useNavigate } from 'react-router-dom';
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers-pro";
import dayjs from 'dayjs';
import Confirmation from "../../../../common/Comfirmation"
import { GetOrgChildren, GetOrgUsers, DeleteOrg, AssignUser, UnassignUser, GrantUser, CopyUsers, UpdateOrgSettings, UpdateIssuer } from "../../../../api";


const OrgSettings = ({ user: u, access }) => {

    const [childOrgs, setChildOrgs] = useState()
    const [childOrg, setChildOrg] = useState()
    const [users, setUsers] = useState()
    const [user, setUser] = useState()
    const [transfer, setTransfer] = useState({})
    const [consultAlert, setConsultAlert] = useState({})
    const [userAccess, setUserAccess] = useState()
    const [newUser, setNewUser] = useState()
    const [copyOrg, setCopyOrg] = useState()
    const [bulkApply, setBulkApply] = useState(false)
    const [newIssuerName, setNewIssuerName] = useState()
    const [newIssuerAet, setNewIssuerAet] = useState()
    const [newTag, setNewTag] = useState('')
    const [deleteConfirmation, setdeleteConfirmation] = useState({
        open: false,
        text: "",
        orgId: undefined,
        api: undefined
    })

    const navigate = useNavigate();

    const hasTransfer = useMemo(() => u.access.filter(e => e.consult || e.transfer).length > 1, [u.access])
    const isParentOrg = childOrg?.id === access.org.id

    const handleSubmit = e => {
        e.preventDefault()
        if (childOrg?.id && newUser)
            AssignUser(bulkApply ? childOrgs.map(e=>e.id) : [childOrg.id], { email: newUser }).then(() => {
                handleChildOrgChange(childOrg)
                setNewUser()
            }).catch(e => e)
    }

    useEffect(() => {
        setChildOrgs()
        setChildOrg()
        setUsers()
        if (!access?.admin)
            navigate('/', { replace: true })
        else
            GetOrgChildren(access.org.id).then(r => setChildOrgs(r.length ? r.sort((a, b) => a.name.localeCompare(b.name)).sort((a, b) => a.id === access.org.id ? -1 : b.id === access.org.id ? 1 : 0) : r))

    }, [access, navigate])

    const handleChildOrgChange = org => {
        setUsers()
        setUser()
        setChildOrg(org)
        setTransfer(org.settings?.transfer || {})
        org.settings?.transfer && setTransfer(org.settings.transfer)
        setConsultAlert(org.settings?.consultAlert || {})
        GetOrgUsers(org.id).then(users => {
            setUsers(users.length ? users.sort((a, b) => a.name.localeCompare(b.name)) : users)
        })
    }

    useEffect(() => {
        setUserAccess(user?.access?.find(r => r.org === childOrg?.id))
    }, [user, childOrg])

    useEffect(() => setBulkApply(false), [childOrg])

    const accessCheckChange = e => {
        if (user?.id && childOrg?.id) {
            if (e.target.name === 'consult') {
                if (!e.target.checked && childOrg?.users?.includes(user?.id)) {
                    // Consult was turned off with requestee on
                    setUserAccessState('requestee', false)
                }
                if (e.target.checked && userAccess.transfer) {
                    // Consult was turned on with transfer on
                    setUserAccessState('transfer', false)
                }
            }
            else if (e.target.name === 'requestee')
                setChildOrgs(cOrgs => {
                    const i = cOrgs.findIndex(o=>o.id===childOrg.id)
                    const copyChildOrg = {...childOrg}
                    const copyUsers = (copyChildOrg.users?.length && [...copyChildOrg.users]) || []
                    if (e.target.checked)
                        copyUsers.push(user.id)
                    else
                        copyUsers.splice(copyUsers.findIndex(g=>g===user.id), 1)
                    copyChildOrg.users = copyUsers
                    setChildOrg(copyChildOrg)
                    cOrgs[i] = copyChildOrg
                    return cOrgs
                })
            setUserAccessState(e.target.name, e.target.checked)
        }
    }
    const setUserAccessState = useCallback((name, value) => {
        GrantUser(bulkApply ? childOrgs.map(e=>e.id) : [childOrg.id], { userId: user.id, feature: name, setting: value }).catch(e => e)
        setUserAccess(x => ({ ...x, [name]: value }))
        setUsers(u => {
            const i = u.findIndex(o=>o.id===user.id)
            const copyUser = {...user}
            const a = copyUser.access.findIndex(o=>o.org===childOrg.id)
            copyUser.access[a][name] = value
            u[i] = copyUser
            return u
        })
    }, [childOrg, user, childOrgs, bulkApply])

    const deleteConfirm = () => {
        deleteConfirmation.api(deleteConfirmation.orgId).then(() => {
            setChildOrgs(i => {
                let orgs = [...i];
                orgs.splice(orgs.findIndex(x => x.id === deleteConfirmation.orgId), 1)
                return orgs;
            })
            setdeleteConfirmation(
                i => (i = { open: false, text: "", orgId: undefined, api: undefined })
            )
            setUsers()
        }).catch(e => e)
    }
    const deleteCancel = () => {
        setdeleteConfirmation(
            (i) => (i = { open: false, text: "", orgId: undefined, api: undefined })
        )
    }
    const deleteClick = org => {
        setdeleteConfirmation(
            (i) =>
            (i = {
                open: true,
                text: `Are you sure you want to delete org: ${org.name}?`,
                orgId: org.id,
                api: DeleteOrg
            })
        )
    }

    const removeUserClick = userId => {
        if (childOrg?.id && userId)
            UnassignUser(bulkApply ? childOrgs.map(e=>e.id) : [childOrg.id], { userId }).then(() => {
                setUser()
                handleChildOrgChange(childOrg)
            }).catch(e => e)
    }

    const copyUsers = () => {
        if (copyOrg?.id && childOrg?.id && copyOrg.id !== childOrg.id) {
            const copyOrgId = copyOrg.id;
            setCopyOrg() // Clear this so the button isn't spammed
            CopyUsers(copyOrgId, { orgId: childOrg.id }).then(() => {
                setUser()
                handleChildOrgChange(childOrg)
            }).catch(e => e)
        }
    }

    const isConsultAlertEnable = useMemo(() => {
        const now = new Date()
        if (consultAlert.end && consultAlert.end < now) return 2
        if (consultAlert.end && consultAlert.end <= consultAlert.start) return 2
        if (consultAlert.start === childOrg?.settings?.consultAlert?.start && consultAlert.end === childOrg?.settings?.consultAlert?.end && consultAlert.text === childOrg?.settings?.consultAlert?.text) {
            return childOrg?.settings?.consultAlert?.start ? 0 : 2
        }
        if (consultAlert.start && consultAlert.text && (consultAlert.start !== childOrg?.settings?.consultAlert?.start || consultAlert.end !== childOrg?.settings?.consultAlert?.end || consultAlert.text !== childOrg?.settings?.consultAlert?.text)) return 1
        return 0
    }, [childOrg, consultAlert])

    const handleSubmitConsultAlert = e => {
        e.preventDefault()
        UpdateOrgSettings(childOrg.id, {...childOrg.settings, consultAlert: isConsultAlertEnable ? consultAlert : null}).then(()=> {
            setChildOrg(e=>({...e, settings: {...e.settings, consultAlert: isConsultAlertEnable ? consultAlert : null}}))
            !isConsultAlertEnable && setConsultAlert({})
        }).catch(e => e)
    }

    const isTransferEnable = useMemo(() => {
        const now = new Date()
        if (transfer.end && transfer.end < now) return 2
        if (transfer.end && transfer.end <= transfer.start) return 2
        if (transfer.start === childOrg?.settings?.transfer?.start && transfer.end === childOrg?.settings?.transfer?.end && transfer.org === childOrg?.settings?.transfer?.org) return 2
        if (transfer.start && transfer.org && (transfer.start !== childOrg?.settings?.transfer?.start || transfer.end !== childOrg?.settings?.transfer?.end || transfer.org !== childOrg?.settings?.transfer?.org)) return 1
        return 0
    }, [childOrg, transfer])

    const handleSubmitTransfer = e => {
        e.preventDefault()
        UpdateOrgSettings(childOrg.id, {...childOrg.settings, transfer: isTransferEnable ? transfer : null}).then(()=> {
            setChildOrg(e=>({...e, settings: {...e.settings, transfer}}))
            !isTransferEnable && setTransfer({})
        }).catch(e => e)
    }

    if (!childOrgs) return <React.Fragment />

    return (
        <Container>
            <form onSubmit={handleSubmit} noValidate>
                <Grid container justifyContent="left" maxWidth="sm" sx={{ mb: 1 }}>
                    <Typography component="h1" variant="h4">Orgs for {access.org?.name}</Typography>
                    <FormControl fullWidth variant="standard">
                        <List sx={{ maxHeight: 300, overflow: "auto" }}>
                            {childOrgs.map(item => (
                                <ListItem key={item.id} disablePadding>
                                    <ListItemButton
                                        onClick={() => handleChildOrgChange(item)}
                                        selected={childOrg?.id === item.id} // Highlights the selected item
                                        sx={item.id === access.org.id ? { color: 'primary.main' } : {}}
                                    >
                                        <ListItemText primary={item.name} />
                                    </ListItemButton>
                                </ListItem>
                            ))}
                        </List>
                    </FormControl>
                </Grid>
                <Grid container spacing={3} justifyContent="left" sx={{ mb: 4 }}>
                    <Button variant="contained" color="success" startIcon={<DomainAddIcon />} component={Link} to="edit">
                        Create
                    </Button>
                    <Button variant="contained" disabled={!childOrg} color="secondary" startIcon={<EditIcon />} component={Link} to={`edit/${childOrg?.id}`}>
                        Edit
                    </Button>
                    <Button variant="contained" disabled={!childOrg} color="error" startIcon={<DomainDisabledIcon />} onClick={() => deleteClick(childOrg)}>
                        Remove
                    </Button>
                </Grid>
                {childOrg && !isParentOrg && (
                    <Grid container spacing={3} justifyContent="left">
                        <Button variant="outlined" startIcon={copyOrg?.id === childOrg?.id ? <CheckCircleOutlineIcon /> : <CopyAllIcon />} disabled={copyOrg?.id === childOrg?.id || !users?.length} onClick={() => setCopyOrg(childOrg)}>
                            {copyOrg?.id === childOrg?.id ? 'Copied' : 'Copy Users'}
                        </Button>
                        {copyOrg && copyOrg.id !== childOrg?.id && (
                            <Button variant="text" color="warning" startIcon={<ContentPasteIcon />} onClick={copyUsers}>
                                From: {copyOrg.name}
                            </Button>
                        )}
                    </Grid>
                )}
                {childOrg && (
                    <Grid container sx={{ mt: 3 }} spacing={3} justifyContent="left">
                        <FormControlLabel control={<Switch checked={!!bulkApply} name="bulk" onChange={e=>setBulkApply(b=>!b)} />} label="Bulk apply user actions to all orgs" />
                    </Grid>
                )}
                {childOrg && users && (
                    <Grid container sx={{ mt: 3 }} justifyContent="left" maxWidth="sm">
                        <Typography component="h1" variant="h4">Users</Typography>
                        <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
                            <List sx={{ maxHeight: 300, overflow: "auto" }}>
                                {users.map(item => (
                                    <ListItem key={item.id} disablePadding secondaryAction={(user?.id === item.id) && <IconButton edge="end" aria-label="delete" disabled={isParentOrg && u.id === item.id} onClick={e => removeUserClick(item.id)}><DeleteIcon /></IconButton>}>
                                        <ListItemButton
                                            onClick={() => setUser(item)}
                                            selected={user?.id === item.id} // Highlights the selected item
                                        >
                                            <ListItemText primary={item.name} secondary={item.email} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </FormControl>
                        <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
                            <TextField required name="email" label="Email Address" value={newUser || ''} onChange={e => setNewUser(e.target.value)} />
                            <Button type="submit" startIcon={<PersonAddIcon />}>Add</Button>
                        </FormControl>
                        {user && userAccess && (
                            <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
                                <FormGroup row>
                                    {isParentOrg && (
                                        <FormControlLabel control={<Switch color="secondary" checked={!!userAccess.admin} name="admin" onChange={accessCheckChange} disabled={isParentOrg && u.id === user?.id} />} label="Admin" />
                                    )}
                                    <FormControlLabel control={<Switch checked={!!userAccess.clinic} name="clinic" onChange={accessCheckChange} />} label="Clinic" />
                                    <FormControlLabel control={<Switch checked={!!userAccess.consult} name="consult" onChange={accessCheckChange} />} label="Teleconsult" />
                                    <FormControlLabel control={<Switch disabled={!!userAccess.consult} checked={!!userAccess.transfer} name="transfer" onChange={accessCheckChange} />} label="Transfer" />
                                    {childOrg?.settings?.prelim && (
                                        <FormControlLabel control={<Switch checked={!!userAccess.prelim} name="prelim" onChange={accessCheckChange} />} label="Prelim" />
                                    )}
                                    <FormControlLabel control={<Switch checked={'requestee' in userAccess ? !!userAccess.requestee : childOrg?.users?.includes(user?.id)} name="requestee" onChange={accessCheckChange} />} label="Assignee" />
                                </FormGroup>
                            </FormControl>
                        )}
                    </Grid>
                )}
            </form>
            {isParentOrg && (
                <Grid container sx={{ mt: 3 }} justifyContent="left" maxWidth="sm">
                    <Typography component="h1" variant="h4">Tags</Typography>
                    <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
                        <List sx={{ maxHeight: 300, overflow: "auto" }}>
                            {(childOrg.settings?.tags || []).map((tag, index) => (
                                <ListItem key={index} disablePadding secondaryAction={
                                    <IconButton edge="end" aria-label="delete" onClick={() => {
                                        const tags = childOrg.settings.tags.filter((_, i) => i !== index)
                                        UpdateOrgSettings(childOrg.id, { ...childOrg.settings, tags }).catch(e => e)
                                        setChildOrg(prev => ({ ...prev, settings: { ...prev.settings, tags } }))
                                    }}>
                                        <DeleteIcon />
                                    </IconButton>
                                }>
                                    <ListItemText primary={tag} />
                                </ListItem>
                            ))}
                        </List>
                    </FormControl>
                    <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
                        <TextField label="Tag" value={newTag} onChange={e => setNewTag(e.target.value.toLowerCase().trimStart())} sx={{ mb: 1 }} />
                        <Button
                            startIcon={<PostAddIcon />}
                            onClick={() => {
                                const trimmed = newTag.trim()
                                if (!trimmed || childOrg.settings?.tags?.includes(trimmed)) return
                                const tags = [...(childOrg.settings?.tags || []), trimmed]
                                UpdateOrgSettings(childOrg.id, { ...childOrg.settings, tags }).catch(e => e)
                                setChildOrg(prev => ({ ...prev, settings: { ...prev.settings, tags } }))
                                setNewTag('')
                            }}
                        >
                            Add Tag
                        </Button>
                    </FormControl>
                </Grid>
            )}
            {childOrg && isParentOrg && (
                <form onSubmit={handleSubmitConsultAlert} noValidate>
                    <Grid container sx={{ mt: 3 }} justifyContent="left" maxWidth="sm">
                        <Typography component="h1" variant="h4">Consultation Alert</Typography>
                        <FormControl sx={{ mb: 2 }} fullWidth variant="standard">
                            <TextField
                                value={consultAlert.text || ''}
                                label="Alert Message"
                                onChange={e => setConsultAlert(v=>({...v, text: e.target.value}))}
                                variant="standard"
                                required
                                multiline
                            />
                        </FormControl>
                        <FormControl sx={{ mb: 2 }} fullWidth variant="standard">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    value={consultAlert.start ? dayjs(consultAlert.start) : null}
                                    name="start"
                                    required
                                    label="Start Time"
                                    onChange={val => val?.$d && setConsultAlert(v=>({...v, start: val?.$d.getTime()}))}
                                    textField={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </FormControl>
                        <FormControl fullWidth variant="standard">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    value={consultAlert.end ? dayjs(consultAlert.end) : null}
                                    name="end"
                                    label="End Time"
                                    onChange={val => val?.$d && setConsultAlert(v=>({...v, end: val?.$d.getTime()}))}
                                    textField={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </FormControl>
                        <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
                            <Button disabled={isConsultAlertEnable === 2} type="submit" startIcon={<MeetingRoomIcon />} color={isConsultAlertEnable ? 'primary' : 'secondary'}>{isConsultAlertEnable ? 'Enable' : 'Disable'}</Button>
                        </FormControl>
                    </Grid>
                </form>
            )}
            {childOrg && isParentOrg && hasTransfer && (
                <form onSubmit={handleSubmitTransfer} noValidate>
                    <Grid container sx={{ mt: 3 }} justifyContent="left" maxWidth="sm">
                        <Typography component="h1" variant="h4">Auto Transfer</Typography>
                        <FormControl sx={{ mb: 2 }} fullWidth variant="standard">
                            <TextField
                                id="org"
                                value={transfer.org || ''}
                                label="Reporting Organization"
                                onChange={e => setTransfer(v=>({...v, org: e.target.value}))}
                                variant="standard"
                                select
                                required
                            >
                                <MenuItem key="0" value=""></MenuItem>
                                {u.access.filter(e => (e.consult || e.transfer) && e.org.id !== childOrg.id).map(e => (
                                <MenuItem key={e.org.id} value={e.org.id}>
                                    {e.org.name}
                                </MenuItem>
                                ))}
                            </TextField>
                        </FormControl>                        
                        <FormControl sx={{ mb: 2 }} fullWidth variant="standard">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    value={transfer.start ? dayjs(transfer.start) : null}
                                    name="start"
                                    required
                                    label="Start Time"
                                    onChange={val => val?.$d && setTransfer(v=>({...v, start: val?.$d.getTime()}))}
                                    textField={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </FormControl>
                        <FormControl fullWidth variant="standard">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    value={transfer.end ? dayjs(transfer.end) : null}
                                    name="end"
                                    label="End Time"
                                    onChange={val => val?.$d && setTransfer(v=>({...v, end: val?.$d.getTime()}))}
                                    textField={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </FormControl>
                        <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
                            <Button disabled={isTransferEnable === 2} type="submit" startIcon={<MeetingRoomIcon />} color={isTransferEnable ? 'primary' : 'secondary'}>{isTransferEnable ? 'Enable' : 'Disable'}</Button>
                        </FormControl>
                    </Grid>
                </form>
            )}
            {isParentOrg && childOrg?.settings?.modalityWorklist && (
                <Grid container sx={{ mt: 3 }} justifyContent="left" maxWidth="sm">
                    <Typography component="h1" variant="h4">Modality Worklist Stations</Typography>
                    <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
                        <List sx={{ maxHeight: 300, overflow: "auto" }}>
                            {(childOrg.issuerAet || []).map((item, index) => (
                                <ListItem key={index} disablePadding secondaryAction={
                                    <IconButton edge="end" aria-label="delete" onClick={() => {
                                        const newIssuerAet = childOrg.issuerAet.filter((_, i) => i !== index);
                                        UpdateIssuer(childOrg.id, newIssuerAet).catch(e => e);
                                        setChildOrg(prev => ({ ...prev, issuerAet: newIssuerAet }));
                                    }}>
                                        <DeleteIcon />
                                    </IconButton>
                                }>
                                    <ListItemText 
                                        primary={item.name || item.aetitle || item} 
                                        secondary={item.aetitle && item.name ? item.aetitle : null}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </FormControl>
                    <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
                        <TextField 
                            label="Station Name" 
                            value={newIssuerName || ''} 
                            onChange={e => setNewIssuerName(e.target.value)}
                            sx={{ mb: 1 }}
                        />
                        <TextField 
                            label="AETitle" 
                            value={newIssuerAet || ''} 
                            onChange={e => setNewIssuerAet(e.target.value?.toLowerCase())}
                            sx={{ mb: 1 }}
                        />
                        <Button 
                            onClick={() => {
                                if (newIssuerAet?.trim()) {
                                    const newEntry = { name: newIssuerName?.trim() || '', aetitle: newIssuerAet.trim() };
                                    const newIssuerAetList = [...(childOrg.issuerAet || []), newEntry];
                                    UpdateIssuer(childOrg.id, newIssuerAetList).catch(e => e);
                                    setChildOrg(prev => ({ ...prev, issuerAet: newIssuerAetList }));
                                    setNewIssuerName('');
                                    setNewIssuerAet('');
                                }
                            }}
                            startIcon={<PostAddIcon />}
                        >
                            Add Station
                        </Button>
                    </FormControl>
                </Grid>
            )}
            <Confirmation
                open={deleteConfirmation.open}
                onCancel={deleteCancel}
                onConfirm={deleteConfirm}
            >
                {deleteConfirmation.text}
            </Confirmation>
        </Container>
    )

}

export default OrgSettings